export interface IUserSearchRequest {
  userNameOrEmail: string;
  includeDisabledUsers: boolean;
}

export class UserSearchRequest implements IUserSearchRequest {
  userNameOrEmail: string;
  includeDisabledUsers: boolean;

  constructor(userNameOrEmail: string, includeDisabledUsers: boolean) {
    this.userNameOrEmail = userNameOrEmail;
    this.includeDisabledUsers = includeDisabledUsers;
  }
}
